module.exports = __webpack_public_path__ + "static/img/home-banners-old.13059e0e.jpg";